import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);

export default function initPortfolio() {
	gsap.timeline({
		scrollTrigger: {
			trigger: '.portfolio-container',
			start: 'center center',
			end: '+=2000',
			pin: '.portfolio-container',
			scrub: true,
		},
	})
		.to('.portfolio-container .service__wrapper:nth-of-type(1)', {
			left: '-100%',
		})
		.to(
			'.portfolio-container .service__wrapper:nth-of-type(2)',
			{
				left: 0,
			},
			'<',
		)
		.to('.portfolio-container .service__wrapper:nth-of-type(2)', {
			left: '-100%',
		})
		.to(
			'.portfolio-container .service__wrapper:nth-of-type(3)',
			{
				left: 0,
			},
			'<',
		)
		.to('.portfolio-container .service__wrapper:nth-of-type(3)', {
			left: '-100%',
		})
		.to(
			'.portfolio-container .service__wrapper:nth-of-type(4)',
			{
				left: 0,
			},
			'<',
		);
}
